import classNames from "classnames";
import { JSXElementConstructor, ReactElement } from "react";
import { Flex } from "../../../../flex";
import { Text } from "../../../../text";
import * as styles from "./image-editor-modal-left-rail-item.module.css";

interface Props {
  label: string;
  onClick: () => void;
  isActive: boolean;
  Icon: (props?: any) => ReactElement<any, string | JSXElementConstructor<any>>;
}

export const ImageEditorModalLeftRailItem = ({
  label,
  onClick,
  isActive,
  Icon,
}: Props) => {
  return (
    <Flex
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      className={classNames(styles.container, { [styles.active]: isActive })}
      onClick={onClick}
    >
      <Icon className={styles.icon} />
      <Text fontSize="sm">{label}</Text>
    </Flex>
  );
};
